import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=0988b7bd&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=0988b7bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988b7bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0988b7bd')) {
      api.createRecord('0988b7bd', component.options)
    } else {
      api.reload('0988b7bd', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=0988b7bd&scoped=true&", function () {
      api.rerender('0988b7bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aCPJKSmnixPH/JS/comp/PopupDialog.vue"
export default component.exports